import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { DEFAULT_PAGE_TITLE } from '@/lib/seoDefaults';

/**
 * Mount once inside the router. On React 19 a route without <SEO> (most
 * portal pages) is left with no <title>: <SEO> released the shell's data-rh
 * tags, and React removed the previous page's title on unmount, so the tab
 * showed the bare URL. After each navigation this restores the default title
 * when none is present. It is marked data-rh, so the next <SEO> page releases
 * it before React inserts its own: never two titles.
 */
export function SeoTitleFallback() {
  // Key on the RESOLVED location: TanStack moves the live location before the
  // old route unmounts, so its <title> would still be present when this ran.
  const resolvedHref = useRouterState({ select: (s) => (s.resolvedLocation ?? s.location).href });
  useEffect(() => {
    if (document.head.querySelector('title')) return;
    const fallback = document.createElement('title');
    fallback.setAttribute('data-rh', 'true');
    fallback.textContent = DEFAULT_PAGE_TITLE;
    document.head.appendChild(fallback);
  }, [resolvedHref]);
  return null;
}
